import { useRouter } from 'next/router'
import PaymentOption from 'types/PaymentOption'
import { useSafeCookieContext } from './useSafeCookieContext'
import { useBackend } from 'context/BackendContext'
import { useEffect, useState } from 'react'

const usePaymentOptions = (): {
  paymentOptions: PaymentOption[] | null
  loading: boolean
  error: Error | undefined
} => {
  const { paymentOptions: serverPaymentOptions, setPaymentOptions } = useBackend()
  const router = useRouter()
  const { cookieCountry } = useSafeCookieContext()

  const [clientPaymentOptions, setClientPaymentOptions] = useState<PaymentOption[] | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error | undefined>(undefined)

  const localeInUrl = router.locale?.toLowerCase() // 'en-gb', 'en-us', etc
  const countryFromLocale = router.locale?.split('-')[1].toLowerCase() // 'gb', 'us', etc
  const countryToUse = cookieCountry?.toLowerCase() || countryFromLocale // Prefer cookie if available

  useEffect(() => {
    if (!localeInUrl || !countryToUse) return

    const fetchData = async () => {
      setLoading(true)
      try {
        const res = await fetch(`/data-payment-options/${localeInUrl}/${countryToUse}`)
        if (!res.ok) throw new Error(`Failed to fetch: ${res.statusText}`)
        const json = await res.json()

        if (json?.paymentOptions) {
          setClientPaymentOptions(json.paymentOptions)
          setPaymentOptions(json.paymentOptions)
        }
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Unknown fetch error'))
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [localeInUrl, cookieCountry, countryToUse, countryFromLocale, setPaymentOptions])

  const paymentOptions = clientPaymentOptions || serverPaymentOptions

  return {
    paymentOptions,
    loading,
    error,
  }
  /* const { data, loading, error } = useQuery(GET_PAYMENT_OPTIONS, {
    variables: { lang, locale: cookieCountry },
    fetchPolicy: 'cache-first',
    skip: !cookieCountry || !router.locale,
  })

  return {
    paymentOptions: data?.getPaymentOption ?? null,
    loading,
    error,
  } */
}

export default usePaymentOptions
